var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatches5Filled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 40,
    fill: "#969EB1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.292 20.3372C41.4313 20.1718 41.5544 20.0609 41.6225 20.0157C42.5013 19.4319 43.825 19.7775 44.3405 20.7976L44.6171 21.3449V42.0523L51.1746 47.2929C54.6652 50.0825 56.3806 51.4613 57.2264 52.3217C57.6433 52.7459 57.7814 52.9795 57.8365 53.1337C57.8886 53.2796 57.8935 53.4194 57.8705 53.7794C57.7781 55.223 56.3477 56.0101 55.1824 55.3974C55.1897 55.4013 55.1872 55.3995 55.1714 55.3886L55.1713 55.3886C55.149 55.3733 55.1006 55.3399 55.0167 55.2788C54.8939 55.1893 54.7274 55.0646 54.5215 54.9079C54.1103 54.595 53.5528 54.1627 52.8964 53.6491C51.5841 52.6222 49.8837 51.2754 48.184 49.919C46.4843 48.5625 44.787 47.1977 43.4808 46.1349C42.8275 45.6033 42.2736 45.1485 41.8668 44.8087C41.6632 44.6386 41.4986 44.4991 41.3778 44.394C41.3172 44.3414 41.2699 44.2994 41.2352 44.2676C41.2098 44.2444 41.1972 44.2322 41.1929 44.228C41.1917 44.2268 41.1911 44.2262 41.1911 44.2262C41.0412 44.0622 40.9995 44.0099 40.9524 43.8652C40.8882 43.6672 40.8272 43.3061 40.785 42.5317C40.7014 40.9977 40.7 38.1116 40.7 32.3118V21.3449L40.9766 20.7976C41.043 20.6662 41.1571 20.4975 41.292 20.3372Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatches5Filled);
export default __webpack_public_path__ + "static/media/watches-5-filled.0dbaac92780dd97f4b9e472b0420f0f6.svg";
export { ForwardRef as ReactComponent };